(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5392],{

/***/ 15392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ElectricPriceToday_ElectricPriceToday; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/antd/es/avatar/index.js + 4 modules
var avatar = __webpack_require__(7134);
// EXTERNAL MODULE: ./node_modules/antd/es/popover/index.js + 3 modules
var popover = __webpack_require__(74627);
// EXTERNAL MODULE: ./node_modules/antd/es/config-provider/index.js + 8 modules
var config_provider = __webpack_require__(88929);
// EXTERNAL MODULE: ./node_modules/antd/es/date-picker/index.js + 68 modules
var date_picker = __webpack_require__(3525);
// EXTERNAL MODULE: ./components/_Electric/ElectricPriceToday/ElectricPriceToday.module.css
var ElectricPriceToday_module = __webpack_require__(76534);
var ElectricPriceToday_module_default = /*#__PURE__*/__webpack_require__.n(ElectricPriceToday_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.js
var dist = __webpack_require__(26495);
// EXTERNAL MODULE: ./node_modules/chartjs-plugin-annotation/dist/chartjs-plugin-annotation.esm.js
var chartjs_plugin_annotation_esm = __webpack_require__(97282);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-right.js
var arrow_right = __webpack_require__(82701);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-down.js
var arrow_down = __webpack_require__(76998);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-up.js
var arrow_up = __webpack_require__(61749);
// EXTERNAL MODULE: ./components/_HomeComponents/SwiperSection/SwiperSection.tsx
var SwiperSection = __webpack_require__(47193);
// EXTERNAL MODULE: ./components/_Landings/B2C/FaqSection/FaqSection.tsx
var FaqSection = __webpack_require__(25917);
// EXTERNAL MODULE: ./constants/questions.constants.ts
var questions_constants = __webpack_require__(36854);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/_Electric/ElectricPriceToday/RichText.tsx





var Introduction = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Introducci\xf3n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "En el mundo actual, donde la energ\xeda es una necesidad b\xe1sica para nuestras vidas diarias, estar al tanto del\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "precio de la luz"
                    }),
                    " ",
                    "es fundamental para\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "ahorrar en nuestra factura"
                    }),
                    " ",
                    "energ\xe9tica. Con el aumento constante de los costos de electricidad, es m\xe1s importante que nunca conocer las fluctuaciones diarias y las mejores horas para consumir energ\xeda. En Fiva, te ayudamos a\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/sube-tu-factura",
                        children: "comparar las tarifas energ\xe9ticas"
                    }),
                    " y encontrar la opci\xf3n m\xe1s econ\xf3mica para tu hogar."
                ]
            })
        ]
    });
};
var WhyElectricityPriceChanges = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "\xbfPor qu\xe9 var\xeda el precio de la luz cada d\xeda?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "El\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "precio de la luz var\xeda diariamente"
                    }),
                    " debido a varios factores:"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Oferta y demanda de electricidad:\xa0La cantidad de electricidad disponible en el mercado y la demanda por parte de los consumidores afectan el precio. Durante los per\xedodos de alta demanda, como las olas de calor o fr\xedo extremo, los precios tienden a aumentar."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Coste de los combustibles:\xa0"
                            }),
                            "Los precios de los combustibles f\xf3siles (gas, carb\xf3n, petr\xf3leo) utilizados para generar electricidad fluct\xfaan en el mercado global, influyendo directamente en el coste de la energ\xeda."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Condiciones meteorol\xf3gicas: Las condiciones clim\xe1ticas afectan la producci\xf3n de energ\xeda renovable (solar, e\xf3lica, hidr\xe1ulica). Por ejemplo, en d\xedas nublados o sin viento, la producci\xf3n de energ\xeda renovable puede ser baja, lo que aumenta la dependencia de fuentes de energ\xeda m\xe1s caras."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Pol\xedticas energ\xe9ticas y tarifas reguladas: Las decisiones gubernamentales sobre impuestos, subsidios y regulaciones pueden afectar significativamente el precio de la electricidad."
                        })
                    })
                ]
            })
        ]
    });
};
var TrafficLight = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "\xbfQuieres saber las horas con los precios mas baratos de luz?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Para ayudarte a entender y aprovechar mejor los precios de energ\xeda, hemos creado un\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "sem\xe1foro de precios"
                    }),
                    " de la luz. Este sem\xe1foro te muestra de manera clara y sencilla cu\xe1les son las\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "mejores horas del d\xeda para consumir energ\xeda"
                    }),
                    " y as\xed ahorrar en tu factura."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ElectricPriceToday_module_default()).imageWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/Images/electric/washing.png",
                    alt: "Sem\xe1foro de precios de la luz",
                    width: 850,
                    height: 500
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "\uD83D\uDC49 \xbfCu\xe1les son las horas m\xe1s econ\xf3micas de consumo el\xe9ctrico?:\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/articulo/cuales-son-las-horas-mas-economicas-de-consumo-electrico-horarios-clave-para-reducir-tu-factura-de-luz",
                        children: "Horarios clave para reducir tu factura de luz"
                    }),
                    "."
                ]
            })
        ]
    });
};
var TipsToSave = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Consejos para ahorrar en tu factura de luz"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "1. Consumo en horas valle"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Aprovecha las\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "horas con precios m\xe1s bajos"
                            }),
                            " ",
                            "(indicadas en verde) para realizar tareas que consumen mucha energ\xeda, como lavar la ropa, usar el lavavajillas o planchar. Programar estos electrodom\xe9sticos para que funcionen en estas franjas horarias puede resultar en un ahorro considerable en tu factura."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "2. Desconecta los electrodom\xe9sticos"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Muchos aparatos contin\xfaan consumiendo energ\xeda incluso cuando est\xe1n apagados, pero conectados a la corriente.\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Desconectar los electrodom\xe9sticos cuando no los est\xe9s usando"
                            }),
                            " ",
                            "puede reducir significativamente el consumo de energ\xeda en modo standby. Considera usar regletas con interruptor para facilitar esta tarea."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "3. Iluminaci\xf3n eficiente"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Sustituye las bombillas incandescentes por\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "bombillas LED"
                            }),
                            ", que consumen menos energ\xeda y tienen una vida \xfatil mucho m\xe1s larga. Adem\xe1s,\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "aprovecha al m\xe1ximo la luz natural"
                            }),
                            " durante el d\xeda y apaga las luces cuando no sean necesarias."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "4. Ajusta la temperatura"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            "Utiliza un\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "termostato programable"
                            }),
                            " para mantener tu hogar a una temperatura confortable sin gastar energ\xeda innecesaria. Ajustar la calefacci\xf3n o el aire acondicionado a una temperatura moderada, y reducir su uso durante las horas que no est\xe1s en casa, puede resultar en un ahorro energ\xe9tico significativo."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "5. Electrodom\xe9sticos eficientes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Invierte en electrodom\xe9sticos de alta eficiencia energ\xe9tica. Aunque pueden tener un costo inicial m\xe1s alto, su consumo de energ\xeda es menor a lo largo de su vida \xfatil, lo que se traduce en ahorros a largo plazo."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "6. Aislamiento del hogar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Mejorar el aislamiento de tu hogar puede reducir la necesidad de calefacci\xf3n y aire acondicionado. Sellar puertas y ventanas, y aislar techos y paredes, ayuda a mantener la temperatura interior sin depender tanto de sistemas de climatizaci\xf3n."
                    })
                ]
            })
        ]
    });
};
var FivaTariffComparator = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Compara tarifas con Fiva"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "En Fiva, te ofrecemos una herramienta f\xe1cil de usar para\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/sube-tu-factura",
                        children: "comparar las tarifas energ\xe9ticas"
                    }),
                    " de diferentes proveedores. Simplemente ingresa tu consumo y te mostraremos las mejores opciones para que puedas elegir la tarifa que m\xe1s te conviene."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ElectricPriceToday_module_default()).imageWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/Images/electric/happyfamily.png",
                    alt: "Comparador de tarifas de Fiva",
                    width: 850,
                    height: 500
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\uD83D\uDC49 \xa1Ahorra dinero en tu factura de luz y encuentra la mejor tarifa con el comprador de tarifas energ\xe9ticas de Fiva! Comparar es f\xe1cil, r\xe1pido y puede hacer una gran diferencia en tu bolsillo. \xa1Empieza a ahorrar hoy mismo!"
            })
        ]
    });
};
var HowFivaWorks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "\xbfC\xf3mo funciona Fiva?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Sube tu factura:\xa0"
                            }),
                            "Sube tu factura o introduce tus datos de consumo energ\xe9tico en nuestra plataforma. Puedes encontrar esta informaci\xf3n en tus facturas de electricidad."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Comparaci\xf3n de tarifas:\xa0Fiva analiza diferentes tarifas ofrecidas por m\xfaltiples proveedores, teniendo en cuenta tus patrones de consumo y preferencias."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Selecci\xf3n de la mejor opci\xf3n:\xa0Te presentamos las opciones m\xe1s econ\xf3micas y te ayudamos a cambiar a la tarifa que mejor se adapte a tus necesidades."
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Ahorro garantizado:\xa0Al elegir la tarifa adecuada, puedes reducir considerablemente tu factura de electricidad."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "Visita nuestro sitio web y empieza a ahorrar en tu factura de luz hoy mismo. Si tienes cualquier duda, no dudes en contactarnos a trav\xe9s de nuestro\xa0",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/contacto",
                        children: "formulario de contacto"
                    }),
                    " en Fiva. Estamos aqu\xed para ayudarte a encontrar la mejor soluci\xf3n energ\xe9tica para tu hogar o negocio."
                ]
            })
        ]
    });
};
var ElectricityPriceToday = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (ElectricPriceToday_module_default())["rich-text-container"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Introduction, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyElectricityPriceChanges, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrafficLight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TipsToSave, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FivaTariffComparator, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowFivaWorks, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    });
};
/* harmony default export */ var RichText = (ElectricityPriceToday);

// EXTERNAL MODULE: ./node_modules/antd/lib/locale/es_ES.js
var es_ES = __webpack_require__(28595);
// EXTERNAL MODULE: ./node_modules/chart.js/dist/chart.js
var chart = __webpack_require__(23148);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/dateUtils.ts
var dateUtils = __webpack_require__(62653);
;// CONCATENATED MODULE: ./components/_Electric/ElectricPriceToday/ElectricPriceToday.tsx

















chart/* Chart.register */.kL.register(chart/* CategoryScale */.uw, chart/* LinearScale */.f$, chart/* PointElement */.od, chart/* LineElement */.jn, chart/* Title */.Dx, chart/* Tooltip */.u, chart/* Legend */.De, chart/* Filler */.Gu, chartjs_plugin_annotation_esm/* default */.Z);
var SmCard = function(param) {
    var children = param.children, icon = param.icon, color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ElectricPriceToday_module_default()).Smcard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                style: {
                    backgroundColor: color,
                    color: "#FFFFFF",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    width: "50px",
                    height: "50px"
                },
                icon: icon
            }),
            children
        ]
    });
};
var AveragePriceCards = function(param) {
    var avgPrice = param.avgPrice, minPrice = param.minPrice, maxPrice = param.maxPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ElectricPriceToday_module_default()).averagePriceCards,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmCard, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {}),
                color: "var(--Aguamarina-Fiva)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        "Precio medio del d\xeda",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            style: {
                                fontSize: "22px",
                                display: "block",
                                fontWeight: 700
                            },
                            children: [
                                avgPrice,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: 400
                                    },
                                    children: "€/kWh"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmCard, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_down/* default */.Z, {}),
                color: "green",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        "Precio m\xe1s barato",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            style: {
                                fontSize: "22px",
                                display: "block",
                                fontWeight: 700
                            },
                            children: [
                                minPrice.toFixed(4),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: 400
                                    },
                                    children: "€/kWh"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SmCard, {
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_up/* default */.Z, {}),
                color: "red",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        textAlign: "center"
                    },
                    children: [
                        "Precio m\xe1s caro",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            style: {
                                fontSize: "22px",
                                display: "block",
                                fontWeight: 700
                            },
                            children: [
                                maxPrice.toFixed(4),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontSize: "16px",
                                        fontWeight: 400
                                    },
                                    children: "€/kWh"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var getColor = function(value, maxPrice) {
    if (value <= 0.6 * maxPrice) return "green";
    if (value <= 0.8 * maxPrice) return "orange";
    return "red";
};
var ResponsiveList = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (ElectricPriceToday_module_default()).responsiveList,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (ElectricPriceToday_module_default()).listItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ElectricPriceToday_module_default()).circle, " ").concat((ElectricPriceToday_module_default()).green)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Precios bajos: Entre un 40 a 60% del precio m\xe1s alto del d\xeda"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (ElectricPriceToday_module_default()).listItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ElectricPriceToday_module_default()).circle, " ").concat((ElectricPriceToday_module_default()).orange)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Precios medios: Entre un 60 a 80% del precio m\xe1s alto del d\xeda"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: (ElectricPriceToday_module_default()).listItem,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((ElectricPriceToday_module_default()).circle, " ").concat((ElectricPriceToday_module_default()).red)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Precios altos: Entre un 80 a 100% del precio m\xe1s alto del d\xeda"
                    })
                ]
            })
        ]
    });
};
var PriceCard = function(param) {
    var prices = param.prices, maxPrice = param.maxPrice;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ElectricPriceToday_module_default()).card,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ElectricPriceToday_module_default()).inercard,
                children: [
                    "Ma\xf1ana",
                    "Tarde",
                    "Noche"
                ].map(function(period) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: period
                            }),
                            prices[period.toLowerCase()].map(function(param) {
                                var time = param.time, value = param.value;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: "5px"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "10px",
                                                height: "10px",
                                                borderRadius: "50%",
                                                backgroundColor: getColor(value, maxPrice),
                                                marginRight: "10px"
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: "22px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        flexGrow: 1
                                                    },
                                                    children: [
                                                        time,
                                                        "h"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: 700
                                                    },
                                                    children: [
                                                        value.toFixed(3),
                                                        " €/kWh"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, time);
                            })
                        ]
                    }, period);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveList, {})
        ]
    });
};
var PriceGraph = function(param) {
    var prices = param.prices;
    var data = {
        labels: prices.map(function(price) {
            return price.time.slice(0, 2) + "h";
        }),
        datasets: [
            {
                label: "Precio €/kWh",
                data: prices.map(function(price) {
                    return price.value;
                }),
                borderColor: "rgba(75, 192, 192, 1)",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                tension: 0.4,
                fill: true
            }, 
        ]
    };
    var avgPrice = prices.reduce(function(acc, price) {
        return acc + price.value;
    }, 0) / prices.length;
    var options = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            },
            title: {
                display: true,
                text: "Precios por horas a lo largo del d\xeda"
            },
            tooltip: {
                callbacks: {
                    label: function label(context) {
                        return "".concat(context.dataset.label, ": ").concat(context.parsed.y.toFixed(2), " €/kWh");
                    }
                }
            },
            annotation: {
                annotations: {
                    line1: {
                        type: "line",
                        yMin: avgPrice,
                        yMax: avgPrice,
                        borderColor: "black",
                        borderWidth: 2,
                        label: {
                            content: "Precio medio: ".concat(avgPrice.toFixed(2), " €/kWh"),
                            enabled: true,
                            position: "center"
                        }
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                }
            },
            y: {
                display: true
            }
        },
        elements: {
            point: {
                radius: 0
            },
            line: {
                borderWidth: 2
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (ElectricPriceToday_module_default()).graphCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                children: "Evoluci\xf3n de los precios a lo largo del d\xeda"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Line */.x1, {
                data: data,
                options: options
            })
        ]
    });
};
var ElectricPriceToday = function(param) {
    var price = param.price, date = param.date;
    var _Math, _Math1;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var router = (0,next_router.useRouter)();
    if (!price || !(price === null || price === void 0 ? void 0 : price.length)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "No hay datos de precio disponibles"
        });
    }
    var pvpc = price[0].attributes.values;
    // Calcular el precio máximo, mínimo y la media
    var maxPrice = (_Math = Math).max.apply(_Math, (0,_to_consumable_array/* default */.Z)(pvpc.map(function(item) {
        return item.value;
    })));
    var minPrice = (_Math1 = Math).min.apply(_Math1, (0,_to_consumable_array/* default */.Z)(pvpc.map(function(item) {
        return item.value;
    })));
    var avgPrice = (pvpc.reduce(function(acc, item) {
        return acc + item.value;
    }, 0) / pvpc.length).toFixed(4);
    // Encontrar las horas correspondientes al máximo y mínimo
    var maxPriceItem = pvpc.find(function(item) {
        return item.value === maxPrice;
    });
    var minPriceItem = pvpc.find(function(item) {
        return item.value === minPrice;
    });
    // Agrupar precios por periodos del día (mañana, tarde, noche)
    var periods = {
        mañana: [],
        tarde: [],
        noche: []
    };
    pvpc === null || pvpc === void 0 ? void 0 : pvpc.forEach(function(item) {
        var hour = parseInt(item.time.split(":")[0], 10);
        if (hour <= 13 && hour >= 6) periods.mañana.push(item);
        else if (hour >= 14 && hour <= 21) periods.tarde.push(item);
        else periods.noche.push(item);
    });
    // Función para formatear la fecha en "DD de MMMM, YYYY"
    var formatDisplayDate = function(dateString) {
        var ref = (0,_sliced_to_array/* default */.Z)(dateString.split("-"), 3), day = ref[0], month = ref[1], year = ref[2];
        var months = {
            enero: "enero",
            febrero: "febrero",
            marzo: "marzo",
            abril: "abril",
            mayo: "mayo",
            junio: "junio",
            julio: "julio",
            agosto: "agosto",
            septiembre: "septiembre",
            octubre: "octubre",
            noviembre: "noviembre",
            diciembre: "diciembre"
        };
        return "".concat(parseInt(day), " de ").concat(months[month.toLowerCase()], ", ").concat(year);
    };
    var handleDateChange = function(date, dateString) {
        var todayDate = new Date().setHours(0, 0, 0, 0) // Set today's date to midnight for comparison
        ;
        var selectedDate = date.toDate().setHours(0, 0, 0, 0);
        if (selectedDate === todayDate) {
            router.push("/precio-luz-hoy");
        } else if (date) {
            var formattedDate = (0,dateUtils/* FormatSlugDate */.IL)(date.toDate());
            router.push("/precio-luz/".concat(formattedDate));
        }
    };
    var today = date ? formatDisplayDate(date) : (0,dateUtils/* formatDate */.p6)(new Date());
    var disabledDate = function(current) {
        var startDate = new Date("2021-06-01");
        var endDate = new Date();
        return current && (current < startDate || current > endDate);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ElectricPriceToday_module_default()).flexColumn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ElectricPriceToday_module_default()).maxWidth,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* default */.Z, {
                            content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    date ? "El precio medio de la luz el dia ".concat(today, " fue") : "El precio medio de la luz hoy es",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        style: {
                                            fontSize: "18px"
                                        },
                                        children: avgPrice
                                    }),
                                    " ",
                                    "€/kWh"
                                ]
                            }),
                            title: "Mensaje de Lucy",
                            trigger: "click",
                            open: visible,
                            onOpenChange: function(visible) {
                                return setVisible(visible);
                            },
                            overlayClassName: "custom-popover-content",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/lucy.svg",
                                alt: "Lucy",
                                className: (ElectricPriceToday_module_default()).pulse,
                                width: 90,
                                height: 90
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: (ElectricPriceToday_module_default()).title,
                                    children: date ? "Precio de la luz el dia ".concat(today, ": hist\xf3rico de precios") : "Precio de la luz hoy: horas m\xe1s baratas"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    className: (ElectricPriceToday_module_default()).subtitle,
                                    children: [
                                        "Medio: ",
                                        avgPrice,
                                        " €/kWh | M\xe1s barato: ",
                                        minPrice.toFixed(4),
                                        " €/kWh a las ",
                                        minPriceItem.time,
                                        "h | M\xe1s caro: ",
                                        maxPrice.toFixed(4),
                                        " €/kWh a las ",
                                        maxPriceItem.time,
                                        "h"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                display: "flex",
                                flexWrap: "wrap",
                                marginTop: "1rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    gap: "10px",
                                    flexWrap: "wrap",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(avatar/* default */.C, {
                                        size: "large",
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "https://res.cloudinary.com/dovplwabx/image/upload/c_fill,w_500,h_500/v1716737990/nbujq55xmvldhk68dbp3.jpg",
                                            alt: "icon logo"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "grey",
                                                    fontSize: "16px"
                                                },
                                                children: "Pablo Andreu"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    color: "var(--fiva-color)",
                                                    fontSize: "16px"
                                                },
                                                children: "Fiva Energ\xeda."
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            className: (ElectricPriceToday_module_default()).text,
                            children: [
                                "Precio de la luz por horas",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                today
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AveragePriceCards, {
                            avgPrice: avgPrice,
                            minPrice: minPrice,
                            maxPrice: maxPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceCard, {
                            prices: periods,
                            maxPrice: maxPrice
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            style: {
                                fontSize: "14px"
                            },
                            children: [
                                "Fuente: Red El\xe9ctrica de Espa\xf1a",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "Precio medio del d\xeda: Media aritm\xe9tica de los precios del d\xeda en funci\xf3n del precio de tarifa. Precio en kilovatios hora."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (ElectricPriceToday_module_default()).calendar,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: (ElectricPriceToday_module_default()).text,
                                    children: "\xbfQuieres saber el precio de la luz de otro d\xeda?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                    htmlFor: "date-picker",
                                    children: "Selecciona una fecha"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(config_provider/* default */.ZP, {
                                    locale: es_ES/* default */.Z,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker/* default */.Z, {
                                        id: "date-picker",
                                        onChange: handleDateChange,
                                        format: "DD MMMM YYYY",
                                        placeholder: "DD/MM/YYYY",
                                        className: (ElectricPriceToday_module_default()).datePicker,
                                        disabledDate: disabledDate
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperSection/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ElectricPriceToday_module_default()).flexColumn,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (ElectricPriceToday_module_default()).maxWidth,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceGraph, {
                            prices: pvpc
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            style: {
                                fontSize: "16px"
                            },
                            children: [
                                "\uD83D\uDC49 Precios para la nueva tarifa de luz 2.0, extra\xeddos de Red El\xe9ctrica de Espa\xf1a sin impuestos a\xf1adidos. Actualizados a ",
                                today,
                                "."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText, {})
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqSection/* default */.Z, {
                questions: questions_constants/* B2cFaq */.Qb
            })
        ]
    });
};
/* harmony default export */ var ElectricPriceToday_ElectricPriceToday = (ElectricPriceToday);


/***/ }),

/***/ 47193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SharedComponents_BasicSwiper_BasicSwiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5306);
/* harmony import */ var _SharedComponents_PhoneSwiper_PhoneSwiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12633);
/* harmony import */ var _SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9772);
/* harmony import */ var _SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14726);
/* harmony import */ var _context_IPTracking_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _Tracking_GoogleTracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94549);
/* harmony import */ var _services_notification_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6818);












var SwiperSection = function() {
    var IPTrackingData = (0,react__WEBPACK_IMPORTED_MODULE_5__.useContext)(_context_IPTracking_context__WEBPACK_IMPORTED_MODULE_4__/* .IPTrackingContext */ .n).IPTrackingData;
    var handleButtonClick = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        (0,_Tracking_GoogleTracking__WEBPACK_IMPORTED_MODULE_6__/* .TrackGoogleAnalyticsEvent */ .b3)("Home Page | Elige la tarifa ideal bot\xf3n", "Home Page | Elige la tarifa ideal bot\xf3n", "Home Page | Elige la tarifa ideal bot\xf3n");
                        return [
                            4,
                            _services_notification_service__WEBPACK_IMPORTED_MODULE_7__/* ["default"].sendNotification */ .Z.sendNotification({
                                title: "Home Page Elige la tarifa ideal",
                                text: "Home Page Elige la tarifa ideal Button clicked\\n IP Track:".concat(IPTrackingData ? IPTrackingData : ""),
                                subject: "Home Page Elige la tarifa ideal",
                                receiver: "SUPER"
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleButtonClick() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10___default().swiper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SharedComponents_BasicSwiper_BasicSwiper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        title: "Comparamos en m\xe1s de 50 compa\xf1\xedas"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/sube-tu-factura",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            "aria-label": "Sube tu factura para comparar tarifas",
                            title: "Sube tu factura para comparar tarifas",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                type: "primary",
                                size: "large",
                                className: (_SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10___default().onlineButtonClass),
                                onClick: handleButtonClick,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Elige la tarifa ideal"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            marginLeft: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/icons/UpVector.svg",
                                            alt: "Up"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10___default().phoneSwiper),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SharedComponents_PhoneSwiper_PhoneSwiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        title: "Comparamos en m\xe1s de 50 compa\xf1\xedas"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: "/sube-tu-factura",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            "aria-label": "Sube tu factura para comparar tarifas",
                            title: "Sube tu factura para comparar tarifas",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                type: "primary",
                                size: "large",
                                className: (_SwiperSection_module_css__WEBPACK_IMPORTED_MODULE_10___default().onlineButtonClass),
                                onClick: handleButtonClick,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "Elige la tarifa ideal"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            marginLeft: "10px"
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/icons/UpVector.svg",
                                            alt: "Up"
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwiperSection);


/***/ }),

/***/ 25917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_joy_AccordionGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19128);
/* harmony import */ var _mui_joy_Accordion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6687);
/* harmony import */ var _mui_joy_AccordionDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69182);
/* harmony import */ var _mui_joy_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70248);
/* harmony import */ var _FaqSection_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20266);
/* harmony import */ var _FaqSection_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_FaqSection_module_css__WEBPACK_IMPORTED_MODULE_2__);






var FaqSection = function(param) {
    var questions = param.questions;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "2rem",
            color: "var(--Morado-Fiva, #401C72)",
            margin: "4rem 0rem 0rem 0rem"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_joy_AccordionGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            sx: {
                width: "100%",
                maxWidth: {
                    xs: "90%",
                    sm: "40rem",
                    md: "40rem",
                    lg: "60rem",
                    xl: "80rem"
                }
            },
            size: "lg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: (_FaqSection_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                    children: "Nosotros te respondemos"
                }),
                questions === null || questions === void 0 ? void 0 : questions.map(function(question, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_joy_Accordion__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        sx: {
                            borderBottom: "1px solid var(--Aguamarina-Fiva, #00F5EA)",
                            "&:last-child": {
                                borderBottom: 0
                            },
                            "&:before": {
                                display: "none"
                            },
                            "& .MuiAccordionSummary-root": {
                                color: "var(--Morado-Fiva, #401C72)",
                                "&:hover": {
                                    backgroundColor: "inherit"
                                }
                            },
                            "& .MuiAccordionDetails-root": {
                                color: "var(--Morado-Fiva, #401C72)",
                                padding: "2rem 0rem"
                            },
                            "& .MuiAccordionSummary-root:hover, .MuiButtonBase-root:hover": {
                                color: "var(--Morado-Fiva, #401C72)"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_joy_AccordionSummary__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                className: (_FaqSection_module_css__WEBPACK_IMPORTED_MODULE_2___default().AccordionSummary),
                                sx: {
                                    fontSize: {
                                        xs: "1.125rem",
                                        sm: "1.25rem",
                                        md: "1.25rem",
                                        lg: "1.25rem",
                                        xl: "1.25rem"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        color: "var(--Morado-Fiva, #401C72)",
                                        fontWeight: "700",
                                        margin: "0.25rem 0rem"
                                    },
                                    children: question.title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_joy_AccordionDetails__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                children: question.content
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqSection);


/***/ }),

/***/ 5306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Swiper_Swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11671);


var BasicSwiper = function(param) {
    var _title = param.title, title = _title === void 0 ? "Comparamos entre m\xe1s de 50 Compa\xf1\xedas El\xe9ctricas" : _title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Swiper_Swiper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        title: title,
        slidesPerView: 6,
        images: [
            "/Images/landing/swiper-logos/Endesa-Logo-2048x1152.png",
            "/Images/landing/swiper-logos/Plenitude-Logo.png",
            "/Images/landing/swiper-logos/Naturgy-ok.png",
            "/Images/landing/swiper-logos/total_logo.png",
            "/Images/landing/swiper-logos/412562538-axpo.png",
            "/Images/landing/swiper-logos/Iberdrola_logo_new.png",
            "/Images/landing/swiper-logos/Logo_Audax.png",
            // "/Images/landing/swiper-logos/Repsol-logo-logotype.png",
            "/Images/landing/swiper-logos/syder_logo.png",
            "/Images/landing/swiper-logos/eleia-logo.png",
            "/Images/landing/swiper-logos/logo-visalia.png",
            "/Images/landing/swiper-logos/gana-energia-logo.png", 
        ],
        headingLevel: "h2"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BasicSwiper);


/***/ }),

/***/ 12633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22546);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65519);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5__);







var PhoneSwiper = function(param) {
    var _title = param.title, title = _title === void 0 ? "Comparamos entre m\xe1s de 50 Compa\xf1\xedas El\xe9ctricas" : _title;
    swiper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].use */ .ZP.use([
        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        fluid: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    style: {
                        textAlign: "center",
                        color: "var(--fiva-color)",
                        fontSize: "1.2rem"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
                    breakpoints: {
                        0: {
                            slidesPerView: 3
                        }
                    },
                    spaceBetween: 20,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
                    ],
                    loop: true,
                    children: [
                        "/Images/landing/swiper-logos/Logo_Audax.png",
                        // "/Images/landing/swiper-logos/Repsol-logo-logotype.png",
                        "/Images/landing/swiper-logos/syder_logo.png",
                        "/Images/landing/swiper-logos/eleia-logo.png",
                        "/Images/landing/swiper-logos/logo-visalia.png",
                        "/Images/landing/swiper-logos/gana-energia-logo.png", 
                    ].map(function(image, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                            style: {
                                minHeight: "14vh",
                                backgroundImage: "url(".concat(image, ")"),
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "contain"
                            }
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
                    breakpoints: {
                        0: {
                            slidesPerView: 3
                        }
                    },
                    spaceBetween: 20,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false,
                        reverseDirection: true
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
                    ],
                    loop: true,
                    children: [
                        "/Images/landing/swiper-logos/Endesa-Logo-2048x1152.png",
                        "/Images/landing/swiper-logos/Plenitude-Logo.png",
                        "/Images/landing/swiper-logos/Naturgy-ok.png",
                        "/Images/landing/swiper-logos/total_logo.png",
                        "/Images/landing/swiper-logos/412562538-axpo.png",
                        "/Images/landing/swiper-logos/Iberdrola_logo_new.png", 
                    ].map(function(image, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                            style: {
                                minHeight: "10vh",
                                backgroundImage: "url(".concat(image, ")"),
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "contain"
                            }
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PhoneSwiper);


/***/ }),

/***/ 11671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22546);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34051);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65519);
/* harmony import */ var swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_autoplay__WEBPACK_IMPORTED_MODULE_5__);







var DynamicHeading = function(param) {
    var _level = param.level, level = _level === void 0 ? "h4" : _level, children = param.children, style = param.style;
    var Tag = level;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        style: style,
        children: children
    });
};
var Swiper = function(param) {
    var title = param.title, slidesPerView = param.slidesPerView, images = param.images, headingLevel = param.headingLevel;
    swiper__WEBPACK_IMPORTED_MODULE_2__/* ["default"].use */ .ZP.use([
        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        fluid: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DynamicHeading, {
                    level: headingLevel,
                    style: {
                        textAlign: "center",
                        color: "var(--fiva-color)",
                        margin: "1em 0em",
                        fontSize: "2rem"
                    },
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
                    breakpoints: {
                        550: {
                            slidesPerView: 2
                        },
                        700: {
                            slidesPerView: 4
                        },
                        1400: {
                            slidesPerView: slidesPerView
                        }
                    },
                    spaceBetween: 50,
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false
                    },
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt
                    ],
                    loop: true,
                    children: images === null || images === void 0 ? void 0 : images.map(function(image, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                            style: {
                                minHeight: "20vh",
                                backgroundImage: "url(".concat(image, ")"),
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "contain"
                            }
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Swiper);


/***/ }),

/***/ 36854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qb": function() { return /* binding */ B2cFaq; },
/* harmony export */   "cU": function() { return /* binding */ FreelanceFaq; },
/* harmony export */   "l6": function() { return /* binding */ CCPPFaq; },
/* harmony export */   "y5": function() { return /* binding */ B2bFaq; }
/* harmony export */ });
var B2bFaq = [
    {
        title: "\xbfC\xf3mo puedo contratar el servicio de luz con Fiva?",
        content: "Contratar a trav\xe9s de Fiva es sencillo. Adjunta tu \xfaltima factura de luz y te ofreceremos una comparativa personalizada con las mejores opciones del mercado. Elige la tarifa que m\xe1s te convenga y completa el proceso de contrataci\xf3n online de tu nueva compa\xf1\xeda, todo desde nuestra plataforma."
    },
    {
        title: "\xbfQu\xe9 ventajas ofrece Fiva?",
        content: "Con nuestro comparador, obtendr\xe1s una selecci\xf3n personalizada de tarifas de luz, ahorrando entre un 15% y 40% en tus facturas. Comparamos m\xe1s de 90 ofertas para darte la mejor opci\xf3n seg\xfan tus necesidades espec\xedficas."
    },
    {
        title: "\xbfTiene alg\xfan coste el proceso de cambio de compa\xf1\xeda el\xe9ctrica?",
        content: "El proceso de cambio a trav\xe9s de Fiva no tiene coste. Facilitamos la comparaci\xf3n y el cambio de compa\xf1\xeda de luz sin gastos adicionales, asegurando tu ahorro desde el inicio."
    },
    {
        title: "\xbfCorro el riesgo de quedarme sin luz durante el cambio?",
        content: "No hay riesgo de interrupci\xf3n en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio el\xe9ctrico. Con Fiva, puedes cambiar de compa\xf1\xeda de manera segura y sin preocupaciones."
    },
    {
        title: "\xbfC\xf3mo elegir la tarifa de luz m\xe1s adecuada para mi empresa o pyme?",
        content: "Fiva te asiste en la elecci\xf3n de la tarifa m\xe1s adecuada analizando el consumo el\xe9ctrico de tu empresa y la potencia contratada. Consideramos el perfil de consumo de tu negocio y comparamos las diferentes opciones del mercado, ofreci\xe9ndote soluciones personalizadas que se ajusten a tus necesidades espec\xedficas y te ayuden a maximizar el ahorro."
    },
    {
        title: "\xbfQu\xe9 aspectos debo considerar al seleccionar una tarifa el\xe9ctrica para mi negocio?",
        content: "Al utilizar Fiva para seleccionar una tarifa el\xe9ctrica para tu empresa, es importante tener en cuenta tu consumo mensual, los tipos de maquinaria utilizados y la potencia contratada. Nuestro servicio te ayuda a evaluar si prefieres una tarifa fija para una previsibilidad en las facturas o una variable para posibles ahorros. Fiva se encarga de comparar estas opciones y te asesora en la decisi\xf3n m\xe1s rentable."
    }, 
];
var B2cFaq = [
    {
        title: "\xbfC\xf3mo puedo contratar el servicio de luz con Fiva?",
        content: "Contratar a trav\xe9s de Fiva es sencillo. Adjunta tu \xfaltima factura de luz y te ofreceremos una comparativa personalizada con las mejores opciones del mercado. Elige la tarifa que m\xe1s te convenga y completa el proceso de contrataci\xf3n online de tu nueva compa\xf1\xeda, todo desde nuestra plataforma."
    },
    {
        title: "\xbfQu\xe9 ventajas ofrece Fiva?",
        content: "Con nuestro comparador, obtendr\xe1s una selecci\xf3n personalizada de tarifas de luz, ahorrando entre un 15% y 40% en tus facturas. Comparamos m\xe1s de 90 ofertas para darte la mejor opci\xf3n seg\xfan tus necesidades espec\xedficas."
    },
    {
        title: "\xbfTiene alg\xfan coste el proceso de cambio de compa\xf1\xeda el\xe9ctrica?",
        content: "El proceso de cambio a trav\xe9s de Fiva no tiene coste. Facilitamos la comparaci\xf3n y el cambio de compa\xf1\xeda de luz sin gastos adicionales, asegurando tu ahorro desde el inicio."
    },
    {
        title: "\xbfCorro el riesgo de quedarme sin luz durante el cambio?",
        content: "No hay riesgo de interrupci\xf3n en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio el\xe9ctrico. Con Fiva, puedes cambiar de compa\xf1\xeda de manera segura y sin preocupaciones."
    },
    {
        title: "\xbfQu\xe9 debo hacer para dar de alta el suministro de luz en una nueva vivienda?",
        content: "Para dar de alta el suministro de luz en una nueva vivienda, \n    Fiva te gu\xeda a trav\xe9s del proceso que incluye elegir una compa\xf1\xeda el\xe9ctrica, \n    decidir la tarifa y la potencia, y proporcionar la documentaci\xf3n necesaria como el Bolet\xedn El\xe9ctrico. \n    Nos encargamos de facilitar el proceso, asesor\xe1ndote en cada paso para asegurar una alta eficiente y adecuada a tus necesidades."
    },
    {
        title: "\xbfC\xf3mo cambio el titular del contrato de la luz?",
        content: "Cambiar el titular del contrato de la luz es un tr\xe1mite sencillo con Fiva. Ya sea porque te mudas a una nueva vivienda o por otros motivos, te asistimos en el proceso, que incluye proporcionar datos personales del nuevo titular y, en algunos casos, modificar las condiciones del contrato. Te aseguramos un cambio de titularidad sin complicaciones y adaptado a tus circunstancias personales."
    }, 
];
var CCPPFaq = [
    {
        title: "\xbfC\xf3mo se puede ahorrar en la factura de luz de una comunidad de propietarios?",
        content: "Ahorrar en la factura de luz de una comunidad de propietarios es posible mediante la optimizaci\xf3n de la potencia contratada, \n     la implementaci\xf3n de medidas de eficiencia energ\xe9tica como iluminaci\xf3n LED, y la elecci\xf3n de tarifas con discriminaci\xf3n horaria. Fiva te ofrece un estudio detallado y asesoramiento personalizado para implementar estas medidas y seleccionar la tarifa que mejor se adapte a las necesidades de la comunidad, maximizando el ahorro."
    },
    {
        title: "\xbfQu\xe9 factores influyen en el consumo de luz en una comunidad de vecinos?",
        content: "Los factores que influyen en el consumo de luz en una comunidad de vecinos incluyen las dimensiones del edificio, el n\xfamero de viviendas, la presencia de ascensor, y las \xe1reas comunes como jardines o piscinas. \n      Fiva te ayuda a identificar estos factores y a evaluar su impacto en el consumo total, proporcionando recomendaciones para optimizar el uso de la energ\xeda y reducir costes."
    },
    {
        title: "\xbfQu\xe9 rol juega un administrador de fincas en la gesti\xf3n del consumo energ\xe9tico de una comunidad?",
        content: "El administrador de fincas juega un papel crucial en la gesti\xf3n del consumo energ\xe9tico de una comunidad. Fiva colabora con estos profesionales para analizar el consumo actual, identificar \xe1reas de mejora y aplicar estrategias de ahorro energ\xe9tico. \n     El administrador es clave en la implementaci\xf3n de estas medidas y en la comunicaci\xf3n con los residentes para fomentar pr\xe1cticas de consumo eficientes."
    },
    {
        title: "\xbfCorro el riesgo de quedarme sin luz durante el cambio?",
        content: "No hay riesgo de interrupci\xf3n en tu suministro de luz durante el proceso de cambio. El cambio es un proceso administrativo que no afecta la continuidad de tu servicio el\xe9ctrico. Con Fiva, puedes cambiar de compa\xf1\xeda de manera segura y sin preocupaciones."
    },
    {
        title: "\xbfEs necesario instalar max\xedmetros en la comunidad de vecinos?",
        content: "La instalaci\xf3n de max\xedmetros en comunidades de vecinos es com\xfan, especialmente en aquellas con suministros de potencias superiores a 15kW, como los que tienen ascensores. Fiva te asesora sobre la necesidad y beneficios de instalar un max\xedmetro, que ayuda a controlar y limitar el consumo de energ\xeda, evitando sobrecargas y optimizando los costes."
    },
    {
        title: "\xbfQu\xe9 opciones de tarifas de gas existen para comunidades de vecinos?",
        content: "Para las comunidades de vecinos, Fiva explora diversas opciones de tarifas de gas, \n    adecuadas tanto para calefacci\xf3n central como para otros usos comunes. Estas pueden incluir tarifas planas o variables, \n    dependiendo de las necesidades y patrones de consumo de la comunidad. Te asesoramos en la elecci\xf3n de la tarifa m\xe1s eficiente, \n    considerando aspectos como el volumen de consumo y las caracter\xedsticas de la instalaci\xf3n de gas de la comunidad."
    }, 
];
var FreelanceFaq = [
    {
        title: "\xbfNecesito tener experiencia en el sector energ\xe9tico?",
        content: "No, en Fiva hemos simplificado tanto la comparativa que puedes hacerlo sin experiencia previa. Adem\xe1s, tendr\xe1s un asesor ayud\xe1ndote siempre que lo necesites."
    },
    {
        title: "\xbfQu\xe9 tipo de soporte recibir\xe9 como colaborador?",
        content: "Como colaborador de Fiva, recibir\xe1s soporte continuo a trav\xe9s de nuestro equipo de asesores expertos. Te proporcionaremos las herramientas y formaci\xf3n necesarias para que puedas ofrecer el mejor servicio a tus clientes."
    },
    {
        title: "\xbfC\xf3mo puedo empezar a vender productos energ\xe9ticos con Fiva?",
        content: "Para empezar a vender productos energ\xe9ticos con Fiva, solo necesitas registrarte en nuestra plataforma. Te guiaremos a trav\xe9s de los primeros pasos y te proporcionaremos toda la informaci\xf3n y recursos necesarios para comenzar."
    },
    {
        title: "\xbfCu\xe1les son los beneficios de ser un colaborador de Fiva?",
        content: "Ser colaborador de Fiva te permite diversificar tu cartera de productos, acceder a comisiones atractivas y recibir formaci\xf3n continua. Adem\xe1s, podr\xe1s ofrecer a tus clientes soluciones energ\xe9ticas innovadoras y eficientes."
    },
    {
        title: "\xbfQu\xe9 tipos de productos energ\xe9ticos puedo vender?",
        content: "Con Fiva, puedes vender una amplia gama de productos energ\xe9ticos, incluyendo cargadores ultra r\xe1pidos, instalaciones solares y bater\xedas solares. Te proporcionamos todo el material de marketing y soporte t\xe9cnico para que puedas presentar estos productos a tus clientes de manera efectiva."
    },
    {
        title: "\xbfC\xf3mo gestiono las ofertas y tarifas para mis clientes?",
        content: "Fiva te facilita la gesti\xf3n de ofertas y tarifas a trav\xe9s de nuestra plataforma en l\xednea. Podr\xe1s comparar diferentes opciones y seleccionar las que mejor se adapten a las necesidades de tus clientes, garantizando siempre el mejor precio y servicio."
    }, 
];


/***/ }),

/***/ 6818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5121);


var NotificationService = /*#__PURE__*/ function() {
    "use strict";
    function NotificationService() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, NotificationService);
        this.api = axios__WEBPACK_IMPORTED_MODULE_1__/* ["default"].create */ .Z.create({
            baseURL: "".concat("https://fiva-server.0f976be2bfde401b8cef.northeurope.aksapp.io/api", "/notification/")
        });
    }
    var _proto = NotificationService.prototype;
    _proto.sendNotification = function sendNotification(mail) {
        return this.api.post("send/", mail);
    };
    return NotificationService;
}();
var notificationService = new NotificationService();
/* harmony default export */ __webpack_exports__["Z"] = (notificationService);


/***/ }),

/***/ 76534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ElectricPriceToday_main__tsyRe","maxWidth":"ElectricPriceToday_maxWidth__HxKMb","averagePriceCards":"ElectricPriceToday_averagePriceCards___JXM3","flexColumn":"ElectricPriceToday_flexColumn__0KXYX","rich-text-container":"ElectricPriceToday_rich-text-container__Kb5FY","title":"ElectricPriceToday_title__jRbFs","subtitle":"ElectricPriceToday_subtitle__8_vhx","imageWrap":"ElectricPriceToday_imageWrap__bqm_3","antdCard":"ElectricPriceToday_antdCard__4ixY_","underline":"ElectricPriceToday_underline___ps8D","inercard":"ElectricPriceToday_inercard__mq1QW","Smcard":"ElectricPriceToday_Smcard__Rg4ib","card":"ElectricPriceToday_card__8p4c8","graphCard":"ElectricPriceToday_graphCard__vyl9D","text":"ElectricPriceToday_text__YJsSK","pulse":"ElectricPriceToday_pulse__dsCQe","chartContainer":"ElectricPriceToday_chartContainer__QEv_P","responsiveList":"ElectricPriceToday_responsiveList__bmwW2","listItem":"ElectricPriceToday_listItem__5emQc","circle":"ElectricPriceToday_circle__FAvfI","green":"ElectricPriceToday_green__zBawf","orange":"ElectricPriceToday_orange__RPFn8","red":"ElectricPriceToday_red__juGOe","calendar":"ElectricPriceToday_calendar__T2zi8","datePicker":"ElectricPriceToday_datePicker__7Foiw","react-datepicker-wrapper":"ElectricPriceToday_react-datepicker-wrapper__Edc7r","react-datepicker__input-container":"ElectricPriceToday_react-datepicker__input-container__38gWr","blogCont":"ElectricPriceToday_blogCont__ZQ4EH"};

/***/ }),

/***/ 9772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"swiper":"SwiperSection_swiper___utPX","phoneSwiper":"SwiperSection_phoneSwiper__KXEDw","onlineButtonClass":"SwiperSection_onlineButtonClass__PBY4b"};

/***/ }),

/***/ 20266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"FaqSection_title__NdklK","AccordionSummary":"FaqSection_AccordionSummary__COBXn"};

/***/ })

}]);